// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React from 'react';
import { KeywordTitle } from '../../../redux/actionCreators/search/searchOnlineCoursesKeywordActions';
import { CardTypes } from '../../../types/Model';
import SearchBox from './SearchBox';

import { S } from './styles';
import { useIntl } from 'react-intl';

interface HeaderProps {
  type: CardTypes;
  keywords: KeywordTitle[];
  commonKeywords: KeywordTitle[];
  updateKeyword: (nextKeyword: string) => void;
  updateKeywordStream: (nextKeyword: string) => void;
}

function Header({
  type,
  keywords,
  commonKeywords,
  updateKeyword,
  updateKeywordStream,
  ...otherProps
}: HeaderProps): JSX.Element {
  const intl = useIntl();

  function getTitle(type: CardTypes): string | null {
    switch (type) {
      case CardTypes.COURSE:
        return intl.formatMessage({ id: 'C006' });
      case CardTypes.LAB:
        return intl.formatMessage({ id: 'C007' });
      case CardTypes.CHALLENGE:
        return intl.formatMessage({ id: 'C010' });
      case CardTypes.EXAM:
        return intl.formatMessage({ id: 'C012' });
      default:
        return null;
    }
  }

  function getPlaceHolder(type: CardTypes): string {
    switch (type) {
      case CardTypes.COURSE:
        return intl.formatMessage({id: 'C001'});
      case CardTypes.LAB:
        return intl.formatMessage({id: 'C002'});
      case CardTypes.CHALLENGE:
        return intl.formatMessage({id: 'C009'});
      case CardTypes.EXAM:
        return intl.formatMessage({ id: 'C011' });
      default:
        return intl.formatMessage({id: 'C001'});
    }
  }

  return (
    <S.Container type={type} {...otherProps}>
      <S.TitleIcon type={type} />
      <S.Title>{getTitle(type)}</S.Title>
      <SearchBox
        type={type}
        placeholder={getPlaceHolder(type)}
        keywords={keywords}
        commonKeywords={commonKeywords}
        handleSearch={updateKeyword}
        handleStream={updateKeywordStream}
      />
    </S.Container>
  )
}

export { Header as default };
